import type { NodeTree } from "@craftjs/core";
import _ from "lodash";
import { Action, Actions } from "src/types";

export type NavigationLink = {
  label: string;
  action: Action;
  noCustomization?: boolean;
};

export const mapNodeName = (nodeName: string) => {
  const aliases = {
    Home: [
      "VrHeader",
      "BrandMaxiCover",
      "HeaderOption1",
      "HeaderOption2",
      "HeaderOption3",
    ],
    About: [
      "Divider",
      "AboutDetails",
      "AboutSummary",
      "DividerPicture",
      "ParagraphPicture",
      "ParagraphPictureOption2",
    ],
    "Learn More": [
      "VideoBlock",
      "VideoWithTitle",
      "VideoWithParagraph",
      "RichTextSection",
      "TopLevelIframe",
    ],
    Gallery: ["Gallery"],
    Sponsors: ["Sponsors"],
    Benefits: ["Benefits"],
    Speakers: ["Speakers", "SpeakersGrid"],
    Expo: ["Booths", "BoothsGrid", "BoothsList"],
    Schedule: ["DefaultSchedule", "EmbeddedSchedule"],
  };

  for (const [key, value] of Object.entries(aliases)) {
    if (value.includes(nodeName)) {
      return key;
    }
  }
};

export function getCurrentSelectionLinks(trees: NodeTree[]): NavigationLink[] {
  const navLinks = trees.reduce<NavigationLink[]>(
    (acc, { nodes, rootNodeId }) => {
      const node = nodes[rootNodeId];

      if (!node || node.displayName === "StandaloneNavigation") {
        return acc;
      }

      const label =
        mapNodeName(node.displayName) ||
        node.custom.displayName ||
        node.displayName;

      const action = {
        kind: Actions.SectionOfPage,
        nodeId: rootNodeId,
      };

      return [
        ...acc,
        {
          label,
          action: action as Action,
        },
      ];
    },
    []
  );

  return _.uniqBy(navLinks, ({ label }) => label);
}
